import React from 'react';
import Button from "@material-ui/core/Button";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { Grid, IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import axios from 'axios';

const ColorButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText("#29479a"),
    backgroundColor: "#29479a",
    width: "auto",
    minWidth: "160px",
    borderRadius: "25px",
    "&:hover": {
      backgroundColor: "#294780",
    },
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  root: {
    overflowY: 'hidden',
    overflowX: 'hidden',
  },  
  link: {
    color: "#29479a"
  },
  mt : {
    marginTop: '5px'
  },
  mb : {
    marginBottom: '20px'
  },
}));

const ResumeUploader = (props) => {
  const classes = useStyles();

  const [file, setFile] = React.useState();
  const [btnState, setBtnState] = React.useState(true);
  const [date, setDate] = React.useState(props.talent.updated_cv);
  const [url, setUrl] = React.useState(props.talent.cv_url);

  const handleChange = event => {
    setFile(event.target.files[0]);
    setBtnState(false);
  }

  const handleSubmit = async event => {
    console.log(event);
    event.preventDefault()
    const formData = new FormData();
    formData.append('file', file)
    const res = await axios.post(process.env.REACT_APP_IP + `/talents/${ props.talent.id }/resume`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    setDate(res.data.updated_cv);
    setUrl(res.data.cv_url);
    document.getElementById('talentResume').value = '';
    setBtnState(true);
  }

  const handleDelete = async () => {
    const res = await axios.delete(process.env.REACT_APP_IP + `/talents/${ props.talent.id }/resume`)
    setDate(res.data.updated_cv);
    setUrl(res.data.cv_url);
  }

  return (  
    <>
      {/* 
      
       */}
      <div className={classes.root}>
      <h4><strong>Resume</strong></h4>
      <Grid container>
        <Grid item xs={12} lg={3} md={12} sm={12}>
        <p>updated: 
          {(date === "resume not found")
              ? <strong> {date}</strong>
              : <strong>
                <a className={classes.link} href={url} target="_blank" rel="noreferrer"> {date}</a>
                <IconButton aria-label="delete" onClick={handleDelete}>
                  <DeleteIcon />
                </IconButton>
              </strong> 
          }
      </p>
        </Grid>
        <Grid item xs={12} lg={8} md={12} sm={12}>
        <form onSubmit={handleSubmit}>
        <Grid container direction='row' justify='flex-start' alignItems='flex-start'>
          <Grid item xs={12} lg={5} md={4} sm={12}>
            <input
            type='file' 
            id='talentResume'
            accept='application/pdf' 
            onChange={handleChange}/>
            <p className={classes.mb}><small>.pdf and less than 2 MB </small></p>
          </Grid>
          <Grid item xs={12} lg={3} md={5} sm={12}>
            <ColorButton type='submit' disabled={btnState}>submit</ColorButton>
            
          </Grid>
        </Grid>
      </form>
        </Grid>
      </Grid>
    </div>
    </>
  );
}
 
export default ResumeUploader;